import { createReducer } from '@reduxjs/toolkit';
import { setPageError, clearPageError } from '../actions';

const initialState = {
  hasErrors: false,
  errors: []
};

const errorsOnPage = createReducer(initialState,
  (builder) => builder
    .addCase(setPageError,
      (state, action) => {
        const { errorMsg } = action.payload;
        if (!state.errors.includes(errorMsg)) {
          return { hasErrors: true, errors: [...state.errors, errorMsg] };
        }
        return state;
      })
    .addCase(clearPageError,
      (state) => {
        return { hasErrors: false, errors: [] };
      })
);

export default errorsOnPage;

/* ERRORS THAT ARE HANDLED
      204 Content: carpetPad 204 Content data is '' -- handled fired in carpetPadSaga
      500 Network Error: carpetPad api failed -- handled in carpetPadSaga
      carpet missing specialOrderSku (carpet hdmsSku) from graphQL call -- handled in superSku.js
      carpet has $0 price - filters out in colorSwatches.js
      invalid omsId in the url
*/